
import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import RestaurantsListView from "./restaurants-list.html";
import RestaurantsEditView from "./restaurants-edit.html";
import FoldersListView from "../folders/folders-list.html";

angular.module("restaurants", [])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('restaurants', {
                url: "/restaurants",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView
            })

            .state('restaurants.list', {
                url: "/list",
                controller: "RestaurantsListCtrl",
                template: RestaurantsListView,
                requiredPermission: ["RESTAURANTS_READ"]
            })           
            .state('restaurants.edit', {
                url: "/edit/:id",
                views: {
                    '': {
                        controller: "RestaurantsEditCtrl",
                        template: RestaurantsEditView
                    },
                    'foldersFiles@restaurants.edit': {
                        controller: "FoldersListCtrl",
                        template: FoldersListView,
                        resolve: {
                            entity_type: [function () { return "restaurants"; }],
                            entity_type_id: ['$stateParams', function ($stateParams) {
                                if (angular.isDefined($stateParams.id) && $stateParams.id != "") {
                                    return $stateParams.id;
                                }
                                return null;
                            }],
                            is_public: [function () { return false; }]
                        }
                    }
                },
                requiredPermission: ["RESTAURANTS_READ"]
            });
    }])
;